module.exports = __webpack_public_path__ + "img/SPM.917ed941.svg";